<template>
    <v-container fluid>
        <v-dialog v-model="dialogDelete" max-width="600px" persistent>
            <v-card>
                <v-card-title class="text-h5">Soll dieser Eintrag wirklich gelöscht werden?</v-card-title>
                <v-card-actions class="pb-5">
                    <v-spacer />
                    <v-btn :color="$store.state.theme.primary" :disabled="deleting_transaction" text @click="closeDelete">Nein</v-btn>
                    <v-btn :color="$store.state.theme.red" :loading="deleting_transaction" outlined @click="deleteItemConfirm">Ja</v-btn>
                    <v-spacer />
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="exportingBelege" persistent max-width="400">
            <v-card>
                <v-card-title class="headline">Exportiere Belege...</v-card-title>
                <v-card-text>
                <v-progress-linear :value="exportProgress" height="20" color="primary" striped>
                    <template v-slot:default>
                    <span>{{ Math.round(exportProgress) }}%</span>
                    </template>
                </v-progress-linear>
                <div class="mt-3 text-center">
                    Bitte warten, die Belege werden exportiert...
                </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-row no-gutters :class="$vuetify.breakpoint.xsOnly ? 'pt-3' : ''">
            <v-col class="d-flex align-center justify-space-between">
                <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" label="Suche" single-line hide-details outlined dense clearable clear-icon="mdi-close-circle" />
                <v-btn v-if="$vuetify.breakpoint.smAndUp" class="ml-5" elevation="1" :color="$store.state.theme.green" @click="dialog = true" dark>
                    <v-icon left>mdi-plus</v-icon>
                    Neue Einnahme / Ausgabe
                </v-btn>
                <v-dialog v-model="dialog" persistent max-width="900px" :fullscreen="$vuetify.breakpoint.xsOnly">
                    <v-card>
                        <v-form ref="form">
                            <v-card-title>
                                <span class="text-h5">{{ formTitle }}</span>
                            </v-card-title>
                            
                            <v-card-text class="mt-3 mb-0 pb-0">
                                <v-row class="my-0 py-0">
                                    <v-col class="my-0 py-0" :cols="editedItem.kategorie === enum_categories['Ausgaben'] && $vuetify.breakpoint.smAndUp ? 6 : 12">
                                        <v-select dense outlined v-model="editedItem.kategorie" :items="categories"
                                            item-text="text" item-value="id" label="Kategorie" @input="changedAmount(-1)" />
                                    </v-col>
                                    <v-col class="my-0 py-0" v-if="editedItem.kategorie === enum_categories['Ausgaben']">
                                        <v-autocomplete 
                                            dense outlined 
                                            v-model="editedItem.verteiler" :items="itemsExpenses"
                                            item-text="text" item-value="id" label="Verteiler"
                                            :rules="[v => !!v || 'Bitte wähle einen Verteiler aus.']"
                                        >
                                            <template v-slot:item="{ item }">
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        {{ item.text }}
                                                        <v-chip x-small class="ml-2">{{ item.nr }}</v-chip>
                                                    </v-list-item-title>
                                                    <v-list-item-subtitle v-if="item.examples" class="text-caption">
                                                        {{ item.examples }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                            </template>
                                        </v-autocomplete>
                                    </v-col>
                                </v-row>
                                <div v-if="editedIndex === -1">
                                    <v-card outlined class="mb-3" v-for="(transaction, index) in transactions_to_insert" :key="transaction.id">
                                        <v-card-title 
                                            v-if="transactions_to_insert.length > 1"
                                            class="d-flex align-center pb-2 text-subtitle-1 font-weight-medium"
                                        >
                                            {{ editedItem.kategorie === enum_categories['Ausgaben'] ? 'Ausgabe' : 'Einnahme' }} {{ index + 1 }}
                                            <v-spacer />
                                            <v-btn 
                                                v-if="transaction.id === transactions_to_insert.length && transactions_to_insert.length > 1"
                                                icon small 
                                                color="red"
                                                @click="removeTransactionRow"
                                            >
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-row class="my-0 pt-3 pb-5 pb-sm-0">
                                                <v-col cols="12" sm="6" class="py-0 my-0">
                                                    <v-text-field 
                                                        dense outlined 
                                                        v-model="transaction.transaction.beschreibung"
                                                        label="Beschreibung" 
                                                        :rules="[v => !!v || 'Bitte gib eine Beschreibung ein.']"
                                                    />
                                                </v-col>
                                                <v-col cols="6" sm="3" class="my-0 py-0">
                                                    <v-menu v-model="transaction.menu" :close-on-content-click="false" offset-y
                                                        max-width="290px" min-width="auto">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field dense outlined :value="formatDate(transaction.transaction.datum)" label="Datum"
                                                                hint="" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs"
                                                                v-on="on" />
                                                        </template>
                                                        <v-date-picker dense outlined first-day-of-week="1" v-model="transaction.transaction.datum" no-title
                                                            @input="transaction.menu = false" />
                                                    </v-menu>
                                                </v-col>
                                                <v-col cols="6" sm="3" class="d-flex my-0 py-0">
                                                    <v-text-field dense outlined type="number"
                                                        @input="changedAmount(transaction.id)"
                                                        v-model="transaction.transaction.betrag" label="Betrag"
                                                        :rules="[v => (v !== null && v !== undefined && v !== '') || 'Bitte gib einen Betrag an.']" 
                                                    />
                                                </v-col>
                                                <!-- Inline Receipt Upload -->
                                                <v-col cols="12" class="py-1">
                                                    <inline-receipt-upload 
                                                        :session="session"
                                                        :receipts="transaction.receipts" 
                                                        @update:receipts="updateReceipts($event, transaction.id)"
                                                        @fetchTransactionReceipts="fetchTransactionReceipts"
                                                        @showError="(arg) => $emit('showError', arg)" 
                                                        @showInfo="(arg) => $emit('showInfo', arg)" 
                                                    />
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </div>
                                <v-row v-else class="my-0 py-0">
                                    <v-col cols="12" sm="4" class="my-1 py-0">
                                        <v-text-field 
                                            dense outlined 
                                            v-model="editedItem.beschreibung"
                                            label="Beschreibung" 
                                            :rules="[v => !!v || 'Bitte gib eine Beschreibung ein.']"
                                        />
                                    </v-col>
                                    <v-col cols="6" sm="3" class="my-1 py-0">
                                        <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition"
                                            offset-y>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field dense outlined v-model="computedDateFormatted" label="Datum"
                                                    hint="" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs"
                                                    v-on="on" />
                                            </template>
                                            <v-date-picker first-day-of-week="1" v-model="editedItem.datum" no-title
                                                @input="menu = false" />
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="6" sm="5" class="my-1 py-0">
                                        <v-text-field 
                                            dense 
                                            outlined 
                                            type="number" 
                                            @input="changedAmount(null)"
                                            :rules="[v => (v !== null && v !== undefined && v !== '') || 'Bitte gib einen Betrag an.']"
                                            v-model="editedItem.betrag" 
                                            label="Betrag" 
                                        />
                                    </v-col>
                                    <!-- Inline Receipt Upload -->
                                    <v-col cols="12">
                                        <inline-receipt-upload 
                                            :key="editedItem.id" 
                                            :session="session"
                                            :receipts="editedItem.receipts" 
                                            @update:receipts="updateReceipts($event, null)" 
                                            @fetchTransactionReceipts="fetchTransactionReceipts"
                                            @showError="(arg) => $emit('showError', arg)" 
                                            @showInfo="(arg) => $emit('showInfo', arg)" 
                                        />
                                    </v-col>
                                </v-row>
                            </v-card-text>

                            <v-card-actions class="mt-0 pt-3 px-4 pb-5">
                                <v-btn v-if="editedIndex === -1" rounded elevation="0" small @click="addTransactionRow">
                                    <v-icon left>mdi-plus</v-icon>
                                    Weitere {{ editedItem.kategorie === enum_categories['Ausgaben'] ? 'Ausgabe' : 'Einnahme' }}
                                </v-btn>
                                <v-spacer />
                                <v-btn :color="$store.state.theme.primary" :disabled="inserting_transaction" text @click="close">
                                    Abbrechen
                                </v-btn>
                                <v-btn :color="$store.state.theme.green" :loading="inserting_transaction" outlined @click="saveTransaction">
                                    Speichern
                                </v-btn>
                            </v-card-actions>
                        </v-form>
                    </v-card>
                </v-dialog>
            </v-col>
        </v-row>
        <v-fab-transition>
            <v-btn
                v-if="$vuetify.breakpoint.xsOnly"
                :color="$store.state.theme.green"
                dark
                fixed
                bottom
                right
                fab
                @click="dialog = true"
            >
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </v-fab-transition>
        <v-data-table 
            dense 
            :headers="headers" 
            :items="fullyFilteredTransactions" 
            :sort-by="sortItems"
            :items-per-page.sync="itemsPerPage"
            :footer-props="{
                'items-per-page-options': [5, 10, 25, 50, 100, -1],
            }"
            @update:sort-by="updateSortItems" 
            :sort-desc="sortByDesc" 
            @update:sort-desc="updateSortItemsDesc"
            :item-class="getRowClass"
            class="elevation-1 mt-3 custom-header-height" 
            @update:items-per-page="saveItemsPerPage"
            @click:row="editItem"
        >
            <template v-slot:header.datum="{ header }">
                <span>{{ header.text }}</span>
                <!-- Date range filter -->
                <v-menu offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                        <v-badge 
                            :color="$store.state.theme.primary" 
                            overlap
                            :content="(startDate ? 1 : 0) + (endDate ? 1 : 0)" 
                            :value="!!(startDate || endDate)"
                        >
                            <v-btn icon v-bind="attrs" v-on="on" small class="mx-2">
                                <v-icon>{{ !!(startDate || endDate) ? 'mdi-filter' : 'mdi-filter-outline' }}</v-icon>
                            </v-btn>
                        </v-badge>
                    </template>
                    <v-card>
                        <v-card-title>Datum filtern</v-card-title>
                        <v-card-text>
                            <v-row>
                                <!-- Start Date Section -->
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="filterDateTextStart"
                                        label="Startdatum"
                                        prepend-inner-icon="mdi-calendar"
                                        @input="updateDatePicker('start')"
                                        outlined
                                        dense
                                        :rules="dateRule"
                                        clearable
                                        clear-icon="mdi-close-circle"
                                    ></v-text-field>
                                    <v-date-picker
                                        class="mt-2"
                                        first-day-of-week="1"
                                        v-model="startDate"
                                        no-title
                                        elevation="1"
                                        @input="(date) => updateTextField('start', date)"
                                        :full-width="$vuetify.breakpoint.smAndDown"
                                    ></v-date-picker>
                                </v-col>

                                <!-- End Date Section -->
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="filterDateTextEnd"
                                        label="Enddatum"
                                        prepend-inner-icon="mdi-calendar"
                                        @input="updateDatePicker('end')"
                                        outlined
                                        dense
                                        :rules="dateRule"
                                        clearable
                                        clear-icon="mdi-close-circle"
                                    ></v-text-field>
                                    <v-date-picker
                                        class="mt-2"
                                        first-day-of-week="1"
                                        v-model="endDate"
                                        no-title
                                        elevation="1"
                                        @input="(date) => updateTextField('end', date)"
                                        :full-width="$vuetify.breakpoint.smAndDown"
                                    ></v-date-picker>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions v-if="endDate || startDate" class="px-4 pb-4">
                            <v-btn text block @click="clearDateFilter">Filter entfernen</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </template>
            <template v-slot:top>
                <v-tabs dense show-arrows color="grey darken-4" :background-color="$store.state.theme.background_tabs">
                    <v-tabs-slider :color="$store.state.theme.primary"></v-tabs-slider>
                    <v-tab @click="filterAll">
                        Alle <v-badge inline :content="nAllTransactions.toString()" :color="$store.state.theme.primary" />
                    </v-tab>
                    <v-tab @click="filterIncome">
                        Einnahmen <v-badge inline :content="nIncomeTransactions.toString()" :color="$store.state.theme.green" />
                    </v-tab>
                    <v-tab @click="filterSpendings">
                        Ausgaben <v-badge inline :content="nSpendingTransactions.toString()" :color="$store.state.theme.red" />
                    </v-tab>
                </v-tabs>
                <v-divider/>
            </template>
            <template v-slot:item.betrag="{ item }">
                <!-- Payment method icon for invoices -->
                <v-tooltip bottom :open-delay="300" v-if="item.paymentMethod">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon 
                      left 
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ item.paymentMethod === 'bankomat' ? 'mdi-credit-card' : (item.paymentMethod === 'cash' ? 'mdi-cash' : 'mdi-bank-transfer') }}
                    </v-icon>
                  </template>
                  <span>{{ item.paymentMethod === 'bankomat' ? 'Betrag per Bankomat erhalten' : (item.paymentMethod === 'cash' ? 'Betrag in Bar erhalten' : 'Betrag per Überweisung erhalten') }}</span>
                </v-tooltip>
                <span v-if="item.betrag > 0" class="green--text font-weight-medium">
                    {{ item.betrag.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }) }}
                </span>
                <span v-else class="font-weight-medium">
                    {{ item.betrag.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }) }}
                </span>
            </template>
            <template v-slot:item.beschreibung="{ item }">
                <span>{{ item.beschreibung }}</span>
                <!-- Receipt icon -->
                <v-tooltip bottom :open-delay="300" v-if="item.receipts.length > 0">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon 
                      right 
                      small
                      class="ml-1"
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-receipt-text-check-outline
                    </v-icon>
                  </template>
                  <span>Es wurde ein Beleg zu dieser Ausgabe hochgeladen.</span>
                </v-tooltip>
            </template>
            <template v-slot:item.datum="{ item }">
                <span>{{ new Date(item.datum).toLocaleString([], { year: 'numeric', month: '2-digit', day: '2-digit' })
                }}</span>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-btn v-if="item.deletable !== false" class="mx-1" elevation="0" fab text x-small
                    :color="$store.state.theme.primary" @click.stop="editItem(item)">
                    <v-icon small dark>mdi-pencil</v-icon>
                </v-btn>
                <v-btn v-if="item.deletable !== false" class="mx-1" elevation="0" fab text x-small color="#f44336"
                    @click.stop="deleteItem(item)">
                    <v-icon small dark>mdi-delete</v-icon>
                </v-btn>
            </template>
            <template v-slot:body.append>
                <tr v-if="isFilterActive">
                    <td class="text-right" colspan="3">
                        Summe aller gefilterten Einträge: 
                        <span class="font-weight-bold">{{ sumOfBetrag.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }) }}</span>
                    </td>
                    <td></td>
                    <td></td>
                </tr>
            </template>
            <template v-slot:no-data>
                <div v-if="loading" class="text-center">
                    <v-progress-circular indeterminate color="primary" />
                </div>
                <div v-else>
                    <span class="mt-5">Bisher wurden keine Einnahmen oder Ausgaben erfasst.</span>
                </div>
            </template>
        </v-data-table>

        <v-row class="mt-5">
            <v-col class="d-flex align-center">
                <span class="mr-3 text-subtitle-1 text-sm-h5">Jahresübersicht</span>
                <v-menu offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn small elevation="0" text v-bind="attrs" v-on="on">
                        
                        <span class="mr-2 text-body-1">
                            {{ $store.state.selected_year }}
                        </span>
                        <v-icon>mdi-calendar-search</v-icon>
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title class="text-overline pb-0">Jahr</v-card-title>
                        <v-card-text class="mb-0 pb-0 px-5">
                        <v-radio-group v-model="$store.state.selected_year" class="my-0 pb-0" @change="changedYear">
                            <v-radio v-for="year in $store.state.active_years" :key="year.jahr" :label="year.jahr.toString()" :value="year.jahr" :color="$store.state.theme.primary" class="mt-1" />
                        </v-radio-group>
                        </v-card-text>
                    </v-card>
                </v-menu>
            </v-col>

            <v-col class="d-flex justify-end align-center">
                <v-menu
                    v-if="hasReceiptsForSelectedYear"
                    open-on-hover
                    offset-y
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            outlined
                            :small="$vuetify.breakpoint.xsOnly"
                            :disabled="loading"
                            v-bind="attrs"
                            v-on="on"
                        >
                        <v-icon left>mdi-microsoft-excel</v-icon>
                            {{ $vuetify.breakpoint.smAndUp ? 'Buchhaltung exportieren' : 'Export' }}
                        <v-icon right>mdi-menu-down</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item @click="loadAndExportExcel($store.state.selected_year)">
                            <v-list-item-icon class="mr-2">
                                <v-icon small>mdi-microsoft-excel</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Nur Jahresabschluss exportieren</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="exportExcelAndReceiptsZip($store.state.selected_year)">
                            <v-list-item-icon class="mr-2">
                                <v-icon small>mdi-folder-zip-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Jahresabschluss & Belege exportieren</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-btn
                    v-else
                    @click="loadAndExportExcel($store.state.selected_year)"
                    outlined
                    :small="$vuetify.breakpoint.xsOnly"
                    :disabled="loading"
                >
                    <v-icon left>mdi-microsoft-excel</v-icon>
                    {{ $vuetify.breakpoint.smAndUp ? 'Buchhaltung exportieren' : 'Export' }}
                </v-btn>
            </v-col>
        </v-row>

        <!-- Jahressummen als separate Karten -->
        <v-row class="mt-1">
            <v-col cols="12" md="6">
                <v-card elevation="1" class="pa-2" style="height: 100%;">
                    <v-card-title class="d-flex align-center justify-center pt-1 pb-2">
                        <v-icon left :color="$store.state.theme.green">mdi-plus-minus-variant</v-icon>
                        <span class="ml-2 text-subtitle-1">Einnahmen / Ausgaben</span>
                    </v-card-title>
                    <v-card-text class="text-body-1 pa-1">
                        <v-row class="my-0">
                            <v-col cols="6" class="text-right my-0 py-0">
                                Einnahmen: 
                            </v-col>
                            <v-col cols="6" class="d-flex align-center justify-start my-0 py-0">
                                <v-icon left small :color="$store.state.theme.green">mdi-plus</v-icon><span class="green--text font-weight-medium">{{ computedEarnings.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }) }}</span>
                            </v-col>
                        </v-row>
                        <v-row class="my-0">
                            <v-col cols="6" class="text-right my-0 py-0">
                                Ausgaben:
                            </v-col>
                            <v-col cols="6" class="d-flex align-center justify-start my-0 py-0">
                                <v-icon left small :color="$store.state.theme.red">mdi-minus</v-icon><span class="red--text font-weight-medium">{{ computedSpendings.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }) }}</span>
                            </v-col>
                        </v-row>
                        <v-row class="my-0">
                            <v-col cols="6" class="text-right my-0 py-0">
                                {{ (computedEarnings - computedSpendings) >= 0 ? 'Gewinn:' : 'Verlust:' }}
                            </v-col>
                            <v-col cols="6" class="d-flex align-center justify-start my-0 py-0">
                                <v-icon left small>mdi-equal</v-icon><span class="font-weight-medium">{{ (computedEarnings - computedSpendings).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }) }}</span>
                            </v-col>
                        </v-row>
                        <div v-if="(hasCashOnlyPayments || hasBankomatPayments || hasTransferPayments) || computedEarningsPerTax.behandlung > 0 || computedEarningsPerTax.supervision > 0 || computedEarningsPerTax.kleinunternehmer > 0 || computedEarningsPerTax.sonstige > 0" class="d-flex align-center">
                            <v-divider class="my-5"></v-divider>
                            <span class="mx-2 text-subtitle-1 font-weight-medium">Art der Umsätze</span>
                            <v-divider class="my-5"></v-divider>
                        </div>

                        <v-row v-if="hasTransferPayments" class="my-0">
                            <v-col cols="7" sm="6" class="d-flex align-center justify-end my-0 py-0">
                                <v-tooltip bottom open-delay="300">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small left v-bind="attrs" v-on="on">mdi-bank-transfer</v-icon>
                                        <span>Umsatz per Überweisung:</span>
                                    </template>
                                    <span>Zahlungen per Banküberweisung</span>
                                </v-tooltip>
                            </v-col>
                            <v-col cols="5" sm="6" class="text-left my-0 py-0">
                                {{ computedEarningsTransfer.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }) }}
                            </v-col>
                        </v-row>

                        <v-row v-if="hasCashOnlyPayments && (hasMixedPayments || !hasBankomatPayments)" class="my-0">
                            <v-col cols="7" sm="6" class="d-flex align-center justify-end my-0 py-0">
                                <v-tooltip bottom open-delay="300">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small left v-bind="attrs" v-on="on">mdi-cash</v-icon>
                                        <span>Umsatz in Bar:</span>
                                    </template>
                                    <span>Nur Barzahlungen (ohne Bankomat)</span>
                                </v-tooltip>
                            </v-col>
                            <v-col cols="5" sm="6" class="text-left my-0 py-0">
                                {{ computedEarningsCashOnly.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }) }}
                            </v-col>
                        </v-row>

                        <v-row v-if="hasBankomatPayments && (hasMixedPayments || !hasCashOnlyPayments)" class="my-0">
                            <v-col cols="7" sm="6" class="d-flex align-center justify-end my-0 py-0">
                                <v-tooltip bottom open-delay="300">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small left v-bind="attrs" v-on="on">mdi-credit-card</v-icon>
                                        <span>Umsatz per Bankomat:</span>
                                    </template>
                                    <span>Zahlungen per Bankomatkarte</span>
                                </v-tooltip>
                            </v-col>
                            <v-col cols="5" sm="6" class="text-left my-0 py-0">
                                {{ computedEarningsBankomat.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }) }}
                            </v-col>
                        </v-row>

                        <v-row v-if="hasMixedPayments" class="my-0">
                            <v-col cols="7" sm="6" class="d-flex align-center justify-end my-0 py-0">
                                <v-tooltip bottom open-delay="300">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small left v-bind="attrs" v-on="on">mdi-cash-multiple</v-icon>
                                        <span>Umsatz in Bar & Bankomat:</span>
                                    </template>
                                    <span>Kombination aller Barzahlungen (inkl. Bankomat) - rechtlich als Barzahlung gewertet</span>
                                </v-tooltip>
                            </v-col>
                            <v-col cols="5" sm="6" class="text-left my-0 py-0">
                                {{ computedEarningsCashAndBankomat.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }) }}
                            </v-col>
                        </v-row>

                        <v-row v-if="computedEarningsPerTax.behandlung > 0" class="my-0">
                            <v-col cols="7" sm="6" class="d-flex justify-end align-center my-0 py-0">
                                <v-tooltip bottom open-delay="300">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small left v-bind="attrs" v-on="on">mdi-stethoscope</v-icon>
                                        Behandlung:
                                    </template>
                                    <span>Umsatzsteuerbefreiung nach § 6 Abs. 1 Z 19 UstG (Behandlung).</span>
                                </v-tooltip>
                            </v-col>
                            <v-col cols="5" sm="6" class="text-left my-0 py-0">
                                {{ computedEarningsPerTax.behandlung.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }) }}
                            </v-col>
                        </v-row>
                        <v-row v-if="computedEarningsPerTax.supervision > 0" class="my-0">
                            <v-col cols="7" sm="6" class="d-flex justify-end align-center my-0 py-0">
                                <v-tooltip bottom open-delay="300">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small left v-bind="attrs" v-on="on">mdi-school-outline</v-icon>
                                        Supervision:
                                    </template>
                                    <span>Umsatzsteuerbefreiung nach § 6 Abs. 1 Z 11 UstG (Ausbildungssupervision in einer Ausbildungseinrichtung).</span>
                                </v-tooltip>
                            </v-col>
                            <v-col cols="5" sm="6" class="text-left my-0 py-0">
                                {{ computedEarningsPerTax.supervision.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }) }}
                            </v-col>
                        </v-row>
                        <v-row v-if="computedEarningsPerTax.kleinunternehmer > 0" class="my-0">
                            <v-col cols="7" sm="6" class="d-flex justify-end align-center my-0 py-0">
                                <v-tooltip bottom open-delay="300">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small left v-bind="attrs" v-on="on">mdi-account-tie-outline</v-icon>
                                        Kleinunternehmer:
                                    </template>
                                    <span>Umsatzsteuerbefreiung nach § 6 Abs. 1 Z 27 UstG (Kleinunternehmer).</span>
                                </v-tooltip>
                            </v-col>
                            <v-col cols="5" sm="6" class="text-left my-0 py-0">
                                {{ computedEarningsPerTax.kleinunternehmer.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }) }}
                            </v-col>
                        </v-row>
                        <v-row v-if="computedEarningsPerTax.sonstige > 0" class="my-0">
                            <v-col cols="7" sm="6" class="d-flex justify-end align-center my-0 py-0">
                                <v-tooltip bottom open-delay="300">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon left v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                                        Nicht zugeordnet:
                                    </template>
                                    <span>Diese Umsätze wurden nicht zugeordnet. Dabei kann es sich um Dienstleistungen ohne zugeordnete Steuerbefreiung oder um sonstige Einnahmen in der Buchhaltung handeln.</span>
                                </v-tooltip>
                            </v-col>
                            <v-col cols="5" sm="6" class="text-left my-0 py-0">
                                {{ computedEarningsPerTax.sonstige.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }) }}
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" md="6">
                <v-card elevation="1" class="pa-2 d-flex flex-column" style="height: 100%;">
                    <v-card-title class="d-flex align-center justify-center pt-1 pb-2 flex-grow-0">
                        <v-icon left :color="$store.state.theme.red">mdi-cart-variant</v-icon>
                        <span class="ml-2 text-subtitle-1">Ausgaben-Verteilung</span>
                    </v-card-title>
                    <v-card-text class="pa-1 d-flex align-center justify-center flex-grow-1">
                        <apexchart v-show="donutChartSeries.length > 0" ref="donutChart" height="210" type="donut" :options="donutChartOptions" :series="donutChartSeries" style="width: 100%;" />
                        <v-sheet v-if="donutChartSeries.length === 0" class="d-flex flex-column justify-center align-center">
                            <v-icon x-large>mdi-emoticon-happy-outline</v-icon>
                            <span class="mt-2">Aktuell keine Ausgaben.</span>
                        </v-sheet>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Chart -->
        <v-card class="mt-3" elevation="1">
            <v-sheet elevation="0" class="pt-1">
                <apexchart ref="chart" height="350" type="bar" color="red" :options="options" :series="series"></apexchart>
            </v-sheet>
        </v-card>
    </v-container>
</template>

<script>
import InlineReceiptUpload from '@/components/InlineReceiptUpload.vue';
import connector from '../helpers/supabase-connector.js'
import cipher from '../helpers/cipher.js'
import apexchart from 'vue-apexcharts'
import dayjs from 'dayjs';
import XLSX from 'xlsx';
import JSZip from 'jszip'

import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

export default {
    props: ['session'],
    components: {
        apexchart,
        InlineReceiptUpload
    },

    data() {
        return {
            exportingBelege: false,
            exportProgress: 0,

            allReceipts: [],

            dateRule: [
                v => (v === null || v === '') || /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[012])\.(\d{4})$/.test(v) || 'Datum im Format TT.MM.JJJJ angeben.',
            ],

            startDate: null,
            endDate: null,

            filterDateTextStart: null,
            filterDateTextEnd: null,

            itemsPerPage: parseInt(localStorage.getItem('buchhaltung-items-per-page')) || 10,

            donutChartOptions: {
                colors: [
                    "#0073e6",
                    "#905f78",
                    "#009eb0",
                    "#9b8bf4",
                    "#606ff3",
                    "#bb87a1",
                    "#376690",
                    "#608ebb",
                ],

                dataLabels: {
                    enabled: false
                },
                legend: {
                    show: false,
                },
                tooltip: {
                    theme: 'light',
                    y: {
                        formatter: function (value) {
                            return value.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
                        }
                    }
                },
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: true,
                                value: {
                                    show: true,
                                    fontSize: '16px', // Schriftgröße für den Betrag
                                },
                                total: {
                                    show: true,
                                    showAlways: true,
                                    label: 'Gesamt',
                                    fontSize: '16px', 
                                    formatter: function (w) {
                                        const total = w.globals.seriesTotals.reduce((a, b) => a + b, 0) || 0;

                                        // check if seriesTotal contains three values
                                        // if so, return total value
                                        // if not, return nothing
                                        if (w?.globals?.seriesTotals?.length > 0) {
                                            return `${total.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}`;
                                        } else {
                                            return '0 €';
                                        }
                                    },
                                }
                            }
                        },
                        
                    }
                },
                labels: [],
                chart: {
                    type: 'donut',
                },
            },
            donutChartSeries: [], // Beispielwerte für die Kategorien

            deleting_transaction: false,
            inserting_transaction: false,

            filter_income: false,
            filter_spending: false,

            headers: [
                { text: 'Datum', value: 'datum' },
                { text: 'Beschreibung', value: 'beschreibung' },
                { text: 'Betrag', value: 'betrag', align: "right" },
                { text: 'Kategorie', value: 'sortKategorie'},
                { text: 'Aktionen', value: 'actions', align: "center", sortable: false },
            ],
            search: '',
            sortItems: ['datum', 'inserted_at'],
            sortByDesc: [true, true],
            editedIndex: -1,
            editedItem: {
                id: null,
                uid: this.session.user.id,
                datum: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString(),
                beschreibung: null,
                betrag: null,
                kategorie: 2, // = Ausgaben
                verteiler: null,
                receipts: [],
            },
            defaultItem: {
                id: null,
                uid: this.session.user.id,
                datum: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString(),
                beschreibung: null,
                betrag: null,
                kategorie: 2, // = Ausgaben
                verteiler: null,
                receipts: [],
            },

            transactions_to_insert: [
                {
                    id: 1,
                    transaction: { // defaultItem
                        id: null,
                        uid: this.session.user.id,
                        datum: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString(),
                        beschreibung: null,
                        betrag: null,
                        kategorie: 2, // = Ausgaben
                        verteiler: null,
                    },
                    menu: false,
                    receipts: []
                }
            ],

            enum_categories: {
                //'Einbuchung': 0,
                'Einnahmen': 1,
                'Ausgaben': 2,
                // 'Miete': 3,
                // 'Rücklagen - Weglegung': 4,
                // 'SVS Teilzahlung': 5,
                // 'SVS Nachzahlung aus Rücklagen': 6,
                // 'Einbuchung - Rücklagen': 7,
                // 'Einbuchung - SVS': 8,
                // 'Einbuchung': 9,
                //'Persönliche Gehaltszahlung': 10,
                //'SVS Quartalszahlung': 11,
                //'Eigenübertrag': 12,
            },

            categories_mapping: {
                0: 'Einbuchung',
                1: 'Einnahmen',
                2: 'Ausgaben',
                // 3: 'Miete',
                // 4: 'Rücklagen - Weglegung',
                // 5: 'SVS Teilzahlung',
                // 6: 'SVS Nachzahlung aus Rücklagen',
                //7: 'Einbuchung', // legacy rücklagen
                //8: 'Einbuchung', // legacy svs
                9: 'Einbuchung', // legacy konto
                10: 'Persönliche Gehaltszahlung',
                11: 'SVS Quartalszahlung',
                12: 'Eigenübertrag',
            },
            default_category: { id: 2, text: 'Ausgaben' },
            categories: [
                { id: 2, text: 'Ausgaben' },
                { id: 1, text: 'Sonstige Einnahmen' },
                //{id: 12, text: 'Eigenübertrag' },   
                //{id: 10, text: 'Persönliche Gehaltszahlung' },
            ],

            itemsExpenses: [
                { id: 1, text: 'Abschreibung als Anlage (AfA)', nr: '9130', examples: '' },
                { id: 2, text: 'Arbeitsmittel / Büro', nr: '9230', examples: 'Papier, Stifte, Druckerpatronen, Büromaterial' },
                { id: 3, text: 'Arbeitszimmer', nr: '9275' },
                //{ id: 4, text: 'Bewirtung' },
                //{ id: 5, text: 'EDV-Aufwand' },
                { id: 6, text: 'Fachliteratur', nr: '9230' },
                { id: 7, text: 'GWG (geringw. Wirtschaftsgut)', nr: '9130' },
                { id: 8, text: 'KFZ-Kosten', nr: '9170', examples: 'ohne AfA, Leasing und Kilometergeld' },
                { id: 22, text: 'Internet', nr: '9230' },
                { id: 24, text: 'Leasing', nr: '9180' },
                { id: 9, text: 'Miete', nr: '9180', examples: 'Praxismiete' },
                { id: 23, text: 'Pflichtversicherungsbeiträge', nr: '9225' },
                { id: 10, text: 'Porto', nr: '9230', examples: 'Briefmarken, Versandkosten, Paketgebühren' },
                { id: 11, text: 'Rechtsberatung', nr: '9230' },
                { id: 12, text: 'Reisekosten', nr: '9160', examples: 'Reise- und Fahrtspesen inkl. Kilometergeld und Diäten' },
                { id: 13, text: 'Sonstiges', nr: '9230' },
                //{ id: 14, text: 'Spenden' },
                { id: 15, text: 'Steuerberatung', nr: '9230' },
                { id: 16, text: 'SVS', nr: '9225' },
                { id: 17, text: 'Telefon', nr: '9230' },
                { id: 21, text: 'Therapiematerial', nr: '9100', examples: 'Therapiespiele, Diagnostikmaterial, Testverfahren' },
                { id: 20, text: 'Versicherung', nr: '9230' },
                { id: 18, text: 'Weiterbildung', nr: '9230' },
                { id: 19, text: 'Werbungskosten', nr: '9200', examples: 'Marketing, Anzeigen, Visitenkarten, Website' },
                { id: 25, text: 'Zinsen und ähnliche Aufwendungen', nr: '9220', examples: 'Zinsen für betriebliche Bankkredite, Darlehen, etc.' }
            ],

            transactions: [],
            invoices: [],
            dialog: false,
            dialogDelete: false,
            menu: false,
            loading: false,

            chart_default_values: {
                1: 0,
                2: 0,
                3: 0,
                4: 0,
                5: 0,
                6: 0,
                7: 0,
                8: 0,
                9: 0,
                10: 0,
                11: 0,
                12: 0,
            },

            options: {
                chart: {
                    id: 'vuechart-overview',
                    toolbar: {
                        show: false
                    },
                    stacked: false,
                },
                xaxis: {
                    categories: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
                },
                yaxis: {
                    labels: {
                        formatter: function (val) {
                            if (val === undefined || val === null) {
                                return ''; // or return a default value like '0'
                            }
                            return val.toFixed(0); // Limits the decimal places to 2
                        }
                    }
                },
                fill: {
                    colors: [this.$store.state.theme.green, this.$store.state.theme.red],
                },
                colors: [this.$store.state.theme.green, this.$store.state.theme.red],
                dataLabels: {
                    enabled: !this.$vuetify.breakpoint.xsOnly,
                    formatter: function (val) {
                        if (val === undefined || val === null) {
                            return ''; // or return a default value like '0'
                        }
                        if (Number.isInteger(val)) {
                            return val.toString(); // Display as is if it's an integer
                        } else {
                            return val.toFixed(2); // Limit the decimal places to 2 if it's not an integer
                        }
                    }
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            // Check if the value is an integer
                            if (val === undefined || val === null) {
                                return ''; // or return a default value like '0'
                            }
                            if (Number.isInteger(val)) {
                                return val.toString(); // Display as is if it's an integer
                            } else {
                                return val.toFixed(2); // Limit the decimal places to 2 if it's not an integer
                            }
                        }
                    }
                },
                title: {},

            },
            series: [],
        };
    },

    watch: {
      '$vuetify.breakpoint.xsOnly': function (val) {
        this.options = {
            ...this.options,
            dataLabels: {
                ...this.options.dataLabels,
                enabled: !val
            }
        }
      }
    },

    methods: {

        async exportExcelAndReceiptsZip(year) {
            this.loading = true;
            this.exportProgress = 0;
            let hasBelege = false;
            try {
                // 1. Generate Excel file as Blob (reuse your logic, but use XLSX.write with type: 'array')
                const workbook = await this.loadAndExportExcel(year, false);
                if (workbook === null) {
                    // error has already been shown
                    this.loading = false;
                    return;
                }

                const excelArray = XLSX.write(workbook, { bookType: 'xlsx', type: 'array', cellStyles: true });
                const excelBlob = new Blob([excelArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

                // 2. Prepare ZIP
                const zip = new JSZip();
                zip.file(`Jahresabschluss_ZEIPSY_${year}.xlsx`, excelBlob);

                // 3. Add receipts for the selected year
                const belegeFolder = zip.folder('Belege');
                // Find all receipts for transactions in the selected year
                const receiptsToExport = this.allReceipts.filter(receipt => {
                    const transaction = this.transactions.find(t => t.id === receipt.tId);
                    return transaction && dayjs(transaction.datum).year() === year;
                });

                if (receiptsToExport.length > 0) {
                    hasBelege = true;
                    this.exportingBelege = true;
                }

                let processed = 0;
                const total = receiptsToExport.length;

                for (const receipt of receiptsToExport) {
                    const transaction = this.transactions.find(t => t.id === receipt.tId);
                    if (!transaction) continue;
                    // Download and decrypt the file
                    const fileData = await connector.downloadFile(this, 'receipts', `${this.session.user.id}/${transaction.id}/`, receipt.storageName);
                    let decryptedFile = fileData;
                    if (receipt.storageName.startsWith("enc:1:") && this.$store.state.aes_key_file) {
                        try {
                            // 1. Convert ArrayBuffer to string
                            const fileDataString = new TextDecoder().decode(fileData);
                            // 2. Parse as JSON
                            const fileDataJSON = JSON.parse(fileDataString);
                            // 3. Decrypt
                            decryptedFile = await cipher.decryptFile(this.$store.state.aes_key_file, fileDataJSON);
                        } catch (e) {
                            console.warn(`Beleg konnte nicht entschlüsselt werden: ${receipt.name}`, e);
                            continue;
                        }
                    }
                    if (!decryptedFile) {
                        console.warn(`Beleg ist leer oder ungültig: ${receipt.name}`);
                        continue;
                    }
                    // Format: YYYY-MM-DD-Filename.extension
                    const datePrefix = dayjs(transaction.datum).format('YYYY-MM-DD');
                    const fileName = `${datePrefix}-${receipt.name}`;
                    belegeFolder.file(fileName, decryptedFile, { binary: true });

                    processed++;
                    this.exportProgress = (processed / total) * 100;
                }

                // 4. Generate and download ZIP
                const zipBlob = await zip.generateAsync({ type: 'blob' });
                const url = URL.createObjectURL(zipBlob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `Jahresabschluss_ZEIPSY_${year}_mit_Belegen.zip`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);

                if (hasBelege) {
                    this.exportingBelege = false;
                    this.exportProgress = 0;
                }

                this.$emit('showInfo', {
                    message: 'Die Buchhaltung und Belege wurden erfolgreich als ZIP heruntergeladen.',
                    timeout: 5000
                });
            } catch (error) {
                if (hasBelege) {
                    this.exportingBelege = false;
                    this.exportProgress = 0;
                }
                this.$emit('showError', { 
                    message: 'Fehler beim Export der Buchhaltung und Belege. Bitte versuche es erneut.',
                    error: error.message || error, 
                    timeout: 10000 
                });
            }
            this.loading = false;
        },

        updateDatePicker(type) {
            if (type === 'start') {
                const parsedDate = dayjs(this.filterDateTextStart, 'DD.MM.YYYY', true);
                if (parsedDate.isValid()) {
                    this.startDate = parsedDate.format('YYYY-MM-DD');
                } else {
                    this.startDate = null;
                }
            } else {
                const parsedDate = dayjs(this.filterDateTextEnd, 'DD.MM.YYYY', true);
                if (parsedDate.isValid()) {
                    this.endDate = parsedDate.format('YYYY-MM-DD');
                } else {
                    this.endDate = null;
                }
            }
        },

        formatDate(date) {
            if (!date) return null;
            return dayjs(date).format('DD.MM.YYYY');
        },

        updateTextField(type, newDate) {
            if (type === 'start') {
                this.filterDateTextStart = this.formatDate(newDate);
            } else {
                this.filterDateTextEnd = this.formatDate(newDate);
            }
        },

        clearDateFilter() {
            this.startDate = null;
            this.endDate = null;
            this.filterDateTextStart = null;
            this.filterDateTextEnd = null;
        },

        saveItemsPerPage(value) {
            localStorage.setItem('buchhaltung-items-per-page', value.toString());
        },

        getCategoryDisplayText(item) {
            let categoryString = this.categories_mapping[item.kategorie] || '';
            const verteilerText = this.itemsExpenses.find(expense => expense.id === item.verteiler)?.text;
            
            if (verteilerText) {
                categoryString = `${categoryString} (${verteilerText})`;
            }
            
            return categoryString;
        },

        filterAll() {
            this.filter_income = false;
            this.filter_spending = false;
        },

        filterIncome() {
            this.filter_income = true;
            this.filter_spending = false;
        },
        filterSpendings() {
            this.filter_income = false;
            this.filter_spending = true;
        },

        dateFilter(value, search, item) {

            // Konvertieren Sie das Datum in einen String im Format 'MM.yyyy'
            const dateString = new Date(item.datum).toLocaleString([], { year: 'numeric', month: '2-digit', day: '2-digit' });
            let categoryString = this.categories_mapping[item.kategorie];

            if (item.verteiler) {
                categoryString = categoryString + ' (' + this.itemsExpenses.find((expense) => expense.id === item.verteiler).text + ')' ;
            } 
            
            // Überprüfen Sie, ob der Suchtext im Datum oder in einem anderen Feld enthalten ist
            return value != null &&
                   search != null &&
                   typeof value === 'string' && (
                        value.toString().toLowerCase().includes(search.toLowerCase()) || 
                        dateString.includes(search) ||
                        categoryString.toLowerCase().includes(search.toLowerCase())
                    );
        },

        addTransactionRow() {
            // Get the last transaction from the array
            const lastTransaction = this.transactions_to_insert[this.transactions_to_insert.length - 1];
            
            const MONTHLY_VERTEILER = ['Miete', 'Telefon', 'Internet', 'Leasing'];

            // Find if current verteiler should increment monthly by matching text
            const isMonthlyVerteiler = this.itemsExpenses
                .filter(item => MONTHLY_VERTEILER.includes(item.text))
                .some(item => item.id === this.editedItem.verteiler);
            
            // Get the date - add one month only for specified verteiler
            const nextDate = lastTransaction.transaction.datum ? 
                (isMonthlyVerteiler) ?
                    dayjs(lastTransaction.transaction.datum).add(1, 'month').format('YYYY-MM-DD') :
                    lastTransaction.transaction.datum :
                this.defaultItem.datum;

            // Create a new transaction object with copied values
            const newTransaction = {
                id: this.transactions_to_insert.length + 1,
                transaction: {
                    ...this.defaultItem,
                    datum: nextDate,
                    beschreibung: lastTransaction.transaction.beschreibung || null,
                    betrag: lastTransaction.transaction.betrag || null,
                },
                menu: false,
                receipts: []
            }

            this.transactions_to_insert.push(newTransaction);
        },

        removeTransactionRow() {
            this.transactions_to_insert.pop()
        },

        getFormatedDate(date) {
            return this.formatDate(date)
        },

        changedYear() {
            localStorage.selected_year = parseInt(this.$store.state.selected_year)

            this.prepareChartData(this.invoices, this.transactions)
        },

        changedAmount(id) {
            if (this.editedItem.kategorie !== this.enum_categories['Ausgaben']) this.editedItem.verteiler = null

            if (id && id >= 0) {
                // here multiple transactions are edited
                // find the transaction with the id and change the amount in the transactions_to_insert array
                for (let i in this.transactions_to_insert) {
                    if (this.transactions_to_insert[i].id === id) {

                        if ([this.enum_categories['Ausgaben']].includes(this.editedItem.kategorie)) {
                            if (this.transactions_to_insert[i].transaction.betrag > 0) this.transactions_to_insert[i].transaction.betrag = -this.transactions_to_insert[i].transaction.betrag
                        } else {
                            if (this.transactions_to_insert[i].transaction.betrag < 0) this.transactions_to_insert[i].transaction.betrag = Math.abs(this.transactions_to_insert[i].transaction.betrag)
                        }
                        break
                    }
                }


            } else if (id === -1) {
                // here we changed the category, now change the transactions_to_insert array

                for (let i in this.transactions_to_insert) {

                    if ([this.enum_categories['Ausgaben']].includes(this.editedItem.kategorie)) {
                        if (this.transactions_to_insert[i].transaction.betrag > 0) this.transactions_to_insert[i].transaction.betrag = -this.transactions_to_insert[i].transaction.betrag
                    } else {
                        if (this.transactions_to_insert[i].transaction.betrag < 0) this.transactions_to_insert[i].transaction.betrag = Math.abs(this.transactions_to_insert[i].transaction.betrag)
                    }
                }

                // and also the single one
                if ([this.enum_categories['Ausgaben']].includes(this.editedItem.kategorie)) {
                    if (this.editedItem.betrag > 0) this.editedItem.betrag = -this.editedItem.betrag
                } else {
                    if (this.editedItem.betrag < 0) this.editedItem.betrag = Math.abs(this.editedItem.betrag)
                }

            } else {
                // here only one transaction is edited
                if ([this.enum_categories['Ausgaben']].includes(this.editedItem.kategorie)) {
                    if (this.editedItem.betrag > 0) this.editedItem.betrag = -this.editedItem.betrag
                } else {
                    if (this.editedItem.betrag < 0) this.editedItem.betrag = Math.abs(this.editedItem.betrag)
                }
            }


        },

        async loadAndExportExcel(year, download = true) {
            try {

                // Load the template
                let bucket = 'public-templates'
                let filename = 'jahresabschluss_20250128.xlsx'
                let path = 'accounting/'
                let arrayBuffer = await connector.downloadFile(this, bucket, path, filename);
                if (arrayBuffer === null) {
                    // error has already been shown
                    return;
                }

                // Parse the loaded file
                const workbook = XLSX.read(arrayBuffer, { cellStyles: true });

                // Remove workbook protection
                // if (workbook.Workbook && workbook.Workbook.WBProps) {
                //     workbook.Workbook.WBProps.lockRevision = false;
                //     workbook.Workbook.WBProps.lockStructure = false;
                //     workbook.Workbook.WBProps.lockWindows = false;
                // }

                // // Remove worksheet protection for each sheet
                // workbook.SheetNames.forEach(sheetName => {
                //     const worksheet = workbook.Sheets[sheetName];
                //     if (worksheet["!protect"]) {
                //         delete worksheet["!protect"];
                //     }
                // });

                // Get the first sheet (adjust as needed)
                //#endregion//const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets["Einnahmen"];

                // using the transactionsFromInvoices, add the following data to the excel file
                // - date
                // - description
                // - amount
                // - hard coded 0 for the tax
                // - formula for the net amount (amount - tax)

                let tableData = [];
                let income = 0;
                let spendings = 0;

                this.transactionsFromInvoices.filter((invoice) => dayjs(invoice.datum).year() === year)
                    .map((transaction) => {
                        return [
                            this.getFormatedDate(transaction.datum),
                            transaction.nummer,
                            transaction.betrag,
                            0,
                            //{t: "n", v: transaction.betrag, f: 'C' + (tableData.length + 2) + '-D' + (tableData.length + 2)}
                        ]
                    })
                    .concat(
                        this.transactions.filter((transaction) => (dayjs(transaction.datum).year() === year) && (transaction.kategorie === 1)) // sonstige Einnahmen
                            .map((transaction) => {
                                return [
                                    this.getFormatedDate(transaction.datum),
                                    transaction.beschreibung,
                                    transaction.betrag,
                                    0,
                                    //{t: "n", v: transaction.betrag, f: 'C' + (tableData.length + 2) + '-D' + (tableData.length + 2)}
                                ]
                            })
                    ).sort((a, b) => dayjs(a[0], "DD.MM.YYYY") - dayjs(b[0], "DD.MM.YYYY")).forEach((transaction) => {
                        tableData.push(transaction)
                    }
                    );

                // iterate through the tableData and add the formulas for the net amount
                tableData.forEach((row, index) => {
                    row.push({ t: "n", v: row[2], f: 'C' + (index + 2) + '-D' + (index + 2) })
                })

                // calculate the sum of the income
                income = tableData.reduce((acc, row) => acc + row[2], 0)

                XLSX.utils.sheet_add_aoa(worksheet, tableData, { origin: "A2" });


                const worksheet_spendings = workbook.Sheets["Ausgaben"];
                tableData = [];

                this.transactions.filter((transaction) => (dayjs(transaction.datum).year() === year) && (transaction.kategorie === 2)).sort((a, b) => dayjs(a.datum) - dayjs(b.datum)).forEach((transaction) => {
                    tableData.push([
                        this.getFormatedDate(transaction.datum),
                        transaction.beschreibung,
                        -transaction.betrag,
                        0,
                        { t: "n", v: -transaction.betrag, f: 'C' + (tableData.length + 2) + '-D' + (tableData.length + 2) },
                        this.itemsExpenses.find((item) => item.id === transaction.verteiler).text
                    ])
                });

                // calculate the sum of the spendings
                spendings = tableData.reduce((acc, row) => acc + row[2], 0)

                XLSX.utils.sheet_add_aoa(worksheet_spendings, tableData, { origin: "A2" });


                const worksheet_overview = workbook.Sheets["Übersicht"];

                tableData = [];

                if (year >= 2024) {
                    tableData.push('abzüglich Grundfreibetrag 15%')
                    tableData.push('')
                    tableData.push({ t: "n", v: (income - spendings) > 33000 ? -4950 : (income - spendings) > 0 ? -(income - spendings) * 0.15 : 0, f: 'IF(D25>33000,-4950,IF(D25>0,-D25*0.15,0))', z: '#,##0.00 "€";-#,##0.00 "€"' })
                } else if (year >= 2022) {
                    tableData.push('abzüglich Grundfreibetrag 15%')
                    tableData.push('')
                    tableData.push({ t: "n", v: (income - spendings) > 30000 ? -4500 : (income - spendings) > 0 ? -(income - spendings) * 0.15 : 0, f: 'IF(D25>30000,-4500,IF(D25>0,-D25*0.15,0))', z: '#,##0.00 "€";-#,##0.00 "€"' })
                } else {
                    tableData.push('abzüglich Grundfreibetrag 13%')
                    tableData.push('')
                    tableData.push({ t: "n", v: (income - spendings) > 30000 ? -3900 : (income - spendings) > 0 ? -(income - spendings) * 0.13 : 0, f: 'IF(D25>30000,-3900,IF(D25>0,-D25*0.13,0))', z: '#,##0.00 "€";-#,##0.00 "€"' })
                }

                XLSX.utils.sheet_add_aoa(worksheet_overview, [tableData], { origin: "B26" });

                if (download) {
                    XLSX.writeFile(workbook, "Jahresabschluss_ZEIPSY_" + year + ".xlsx", { compression: false, cellStyles: true });
                    this.$emit('showInfo', {
                        message: 'Die Buchhaltung wurde erfolgreich erstellt und heruntergeladen.',
                        timeout: 5000
                    });
                } else {
                    return workbook;
                }
                
            } catch (error) {
                console.error("Error processing Excel file:", error);
                // emit error
                this.$emit('showError', { 
                    message: 'Fehler beim Export der Buchhaltung. Bitte versuche es erneut.',
                    error: error.message || error, 
                    timeout: 10000 
                });
                return null;
            }
        },

        updateSortItems(sortBy) {
            // to correclty sort items when there are two transactions on the same day.
            if (sortBy.includes('datum')) {
                sortBy.push('updated_at')
            } else {
                sortBy = sortBy.filter((item) => item !== 'updated_at')
            }
            this.sortItems = sortBy
        },

        updateSortItemsDesc(sortByDesc) {
            if (this.sortItems.length === 0) {
                sortByDesc = []
            } else if (this.sortItems.length === 2) {
                sortByDesc = [sortByDesc[0], sortByDesc[0]]
            }
            this.sortByDesc = sortByDesc
        },

        getRowClass(item) {
            if (item.deletable !== false) {
                return 'clickable-row';
            }
            return null;
        },

        editItem(item) {
            if (item.deletable === false) {
                return;
            }
            this.editedIndex = item.id;
            this.editedItem = Object.assign({}, item);
            this.editedItem.receipts = item.receipts ? [...item.receipts] : [];
            this.dialog = true;
        },

        deleteItem(item) {
            this.editedIndex = item.id
            this.editedItem = Object.assign({}, item)
            this.dialogDelete = true
        },

        async deleteItemConfirm() {
            this.deleting_transaction = true;
            let deleted = await connector.delete(this, 'transaktionen', 'id', this.editedIndex);
            if (!deleted) {
                // error was already shown
                this.deleting_transaction = false;
                return;
            }
            await this.initialize();
            this.deleting_transaction = false;
            this.closeDelete();
            this.$emit('showInfo', {
                message: 'Der Eintrag wurde erfolgreich gelöscht.',
                timeout: 5000
            });
        },

        close() {
            this.transactions_to_insert = [
                {
                    id: 1,
                    transaction: Object.assign({}, this.defaultItem),
                    menu: false,
                    receipts: []
                }
            ];
            this.dialog = false;
            this.$nextTick(() => {
                this.$refs.form.resetValidation();
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },

        closeDelete() {
            this.dialogDelete = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },

        async initialize() {
            this.loading = true

            let active_years = await connector.getDataOnly(this, 'vwaktivejahre', 'jahr', false);
            if (active_years !== -1) {
                // error has already been display in case of -1
                // but if we cannot fetch, we just do not set it and hope that it is already set in store.
                // otherwise the default with [] is used.
                this.$store.state.active_years = active_years;
            }
            
            let transactions = await connector.getDataOnly(this, 'vwtransaktionen', ['datum', 'inserted_at'], false);
            if (transactions !== -1) {
                // same here, only update on succesfull retrieval, otherwise do not modify the value.
                this.transactions = transactions;
            }

            let invoices = await connector.getDataOnly(this, 'vwrechnungen_v2', 'datum', false);
            // here we do not check for -1, as the decryptDataAsync function does that.
            this.invoices = await cipher.decryptDataSync(this, invoices);

            this.allReceipts = await this.fetchReceipts();

            this.loading = false;
            // filter paid invoices by selected_year and then aggregate them by month and pass it as data to the prepareChartData function

            this.prepareChartData(invoices, this.transactions);
        },

        async saveTransaction() {

            if (!this.isFormValid) {
                this.$nextTick(() => {
                    if (this.$refs.form) {
                        this.$refs.form.validate();
                    }
                });
                return;
            }
            
            let toInsert = Object.assign({}, this.editedItem);
            delete toInsert.id;

            if (toInsert.kategorie === this.enum_categories['Ausgaben'] && !toInsert.verteiler) {
                this.$emit('showError', { message: 'Bitte wähle einen Verteiler aus!', timeout: 10000 });
                return;
            }

            if (toInsert.kategorie !== this.enum_categories['Ausgaben']) delete toInsert.verteiler;

            if (this.editedIndex > -1) {
                // updated 

                if (!toInsert.beschreibung) {
                    this.$emit('showError', { message: 'Bitte gib eine Beschreibung ein!', timeout: 10000 });
                    return;
                }

                if (toInsert.betrag === null || toInsert.betrag === undefined || toInsert.betrag === '') {
                    this.$emit('showError', { message: 'Bitte gib einen Betrag an.', timeout: 10000 });
                    return;
                }

                this.inserting_transaction = true;
                let updated = await connector.update(this, 'transaktionen', {
                    datum: toInsert.datum,
                    beschreibung: toInsert.beschreibung,
                    betrag: toInsert.betrag,
                    kategorie: toInsert.kategorie,
                    verteiler: toInsert.verteiler,
                }, this.editedIndex);

                if (!updated) {
                    // error has already been displayed
                    this.inserting_transaction = false;
                    return;
                }

                let deleted = true;
                // Process deletion: for every receipt that is not new and marked for deletion, remove it from the bucket.
                let files_to_delete = this.editedItem.receipts
                    .filter((file) => file.toDelete && !file.isNew)
                    .map((file) => file.storageName);
                if (files_to_delete.length > 0) {
                    deleted = await connector.deleteFiles(this, 'receipts', this.session.user.id + '/' + this.editedItem.id + '/', files_to_delete);
                    if (!deleted) {
                        // error has already been shown
                        // but in this case, continue with the rest.
                    }
                }

                // Process new receipts: Upload only receipts that are marked as new.
                let uploaded = true;
                let newReceipts = this.editedItem.receipts.filter((file) => file.isNew);
                if (newReceipts.length > 0) {
                    uploaded = await this.uploadReceiptsForTransaction({
                        transaction: this.editedItem,
                        receipts: newReceipts
                    });
                }

                await this.initialize();
                this.inserting_transaction = false;
                this.close();
                if (deleted && uploaded) {
                    this.$emit('showInfo', {
                        message: 'Der Eintrag wurde erfolgreich aktualisiert.',
                        timeout: 5000
                    });
                }

            } else {
                // create new

                let toInserts = this.transactions_to_insert.map((transaction) => {
                    let toInsert = JSON.parse(JSON.stringify(transaction.transaction));

                    return {
                        beschreibung: toInsert.beschreibung,
                        betrag: toInsert.betrag,
                        datum: toInsert.datum,
                        uid: toInsert.uid,
                        kategorie: this.editedItem.kategorie,
                        verteiler: this.editedItem.verteiler

                    };
                })

                // check if all transactions have a description
                for (let i in toInserts) {
                    if (!toInserts[i].beschreibung) {
                        this.$emit('showError', { message: 'Bitte gib überall eine Beschreibung an.', timeout: 10000 });
                        return;
                    }
                }

                // check if all transactions have an amount
                for (let i in toInserts) {
                    if (toInserts[i].betrag === null || toInserts[i].betrag === undefined || toInserts[i].betrag === '') {
                        this.$emit('showError', { message: 'Bitte gib überall einen Betrag an.', timeout: 10000 });
                        return;
                    }
                }

                this.inserting_transaction = true;
                let inserted = await connector.inserts(this, 'transaktionen', toInserts);
                if (inserted === null) {
                    // error has already been shown
                    this.inserting_transaction = false;
                    return;
                }

                for (let i = 0; i < this.transactions_to_insert.length; i++) {
                    const id = inserted[i].id;
                    this.transactions_to_insert[i].transaction.id = id;
                }

                let uploaded = true;
                for (let transObj of this.transactions_to_insert) {
                    uploaded = await this.uploadReceiptsForTransaction(transObj);
                }
                
                await this.initialize();
                this.inserting_transaction = false;
                this.close();

                let message = 'Der Eintrag wurde erfolgreich gespeichert.';
                if (toInserts.length > 1) {
                    message = 'Die Einträge wurden erfolgreich gespeichert.';
                }
                if (uploaded) {
                    this.$emit('showInfo', {
                        message: message,
                        timeout: 5000
                    });
                }
            }
        },

        prepareChartData(invoices, transactions) {

            let data = invoices.filter((invoice) => invoice.bezahlt && dayjs(invoice.bezahlt).year() === this.$store.state.selected_year)
                .concat(
                    transactions.filter((transaction) => dayjs(transaction.datum).year() === this.$store.state.selected_year && transaction.kategorie === this.enum_categories['Einnahmen'])
                        .map((transaction) => {
                            return {
                                id: transaction.id,
                                datum: transaction.datum,
                                rechnungs_betrag: transaction.betrag,
                                bezahlt: transaction.datum,
                            }
                        })
                )
                .reduce((acc, invoice) => {
                    let month = dayjs(invoice.bezahlt).month() + 1
                    if (acc[month]) {
                        acc[month].earnings += invoice.rechnungs_betrag
                    } else {
                        acc[month] = {
                            monat: month,
                            earnings: invoice.rechnungs_betrag,
                            spendings: 0
                        }
                    }
                    return acc
                }, {})

            // now filter the transactions by selected_year and then aggregate them by month and pass it as data to the prepareChartData function
            transactions.filter((transaction) => dayjs(transaction.datum).year() === this.$store.state.selected_year && transaction.kategorie === this.enum_categories['Ausgaben'])
                .reduce((acc, transaction) => {
                    let month = dayjs(transaction.datum).month() + 1
                    if (acc[month]) {
                        acc[month].spendings += -transaction.betrag
                    } else {
                        acc[month] = {
                            monat: month,
                            earnings: 0,
                            spendings: -transaction.betrag
                        }
                    }
                    return acc
                }, data)

            // now remove the first level of the object and pass it to the prepareChartData function
            data = Object.values(data)

            let chart_data_earnings = Object.assign({}, this.chart_default_values)
            let chart_data_spendings = Object.assign({}, this.chart_default_values)

            if (data !== 0) {
                for (let i in data) {
                    chart_data_earnings[data[i].monat] = data[i].earnings
                    chart_data_spendings[data[i].monat] = data[i].spendings
                }
            }

            let chart_array_spendings = [];
            let chart_array_earnings = [];

            let sum = 0;
            let count = 0;
            for (let i = 1; i < 13; i++) {
                chart_array_earnings.push(chart_data_earnings[i]);
                chart_array_spendings.push(chart_data_spendings[i]);

                if (chart_data_earnings[i] || chart_data_spendings[i]) {
                    sum += (chart_data_earnings[i] - chart_data_spendings[i]);
                    count++;
                }
            }

            let y_axis_mean = [];
            // calculate the average
            if (count > 0) {
                y_axis_mean = [
                    {
                        y: sum / count,
                        borderColor: '#000000',
                        strokeDashArray: 6,
                        width: '100%',
                        label: {
                            borderColor: '#000000',
                            // offsetX: -90,
                            style: {
                                fontWeight: 600,
                                fontSize: '12px',
                            },
                            text: (sum >= 0 ? 'Ø Gewinn: ' : 'Ø Verlust: ') + Math.round(sum / count) + ' €',
                        }
                    }
                ];
            }

            this.series = [
                {
                    name: 'Einnahmen',
                    data: [...chart_array_earnings],
                },
                {
                    name: 'Ausgaben',
                    data: [...chart_array_spendings],
                },
            ]
            
            this.options = {
                ...this.options,
                annotations: {
                    yaxis: y_axis_mean,
                },
            }

            // donut chart

            let donut_data = this.itemsExpenses.reduce((acc, expense) => {
                acc[expense.text] = 0;
                return acc;
            }, {});

            transactions.filter((transaction) => dayjs(transaction.datum).year() === this.$store.state.selected_year && transaction.kategorie === this.enum_categories['Ausgaben'])
                .forEach((transaction) => {
                let category = this.itemsExpenses.find(expense => expense.id === transaction.verteiler);
                if (category) {
                    donut_data[category.text] += -transaction.betrag;
                }
                });

            // Remove entries where the value is zero
            donut_data = Object.fromEntries(
                Object.entries(donut_data).filter(([key, value]) => value !== 0)
            );


            this.donutChartSeries = Object.values(donut_data);
            this.donutChartOptions = {
                ...this.donutChartOptions,
                labels: Object.keys(donut_data)
            };
        },

        async uploadReceiptsForTransaction(transObj) {
            // Loop over each locally stored receipt file for the transaction.
            let success = true;
            const userId = this.session.user.id;
            const transactionId = transObj.transaction.id;
            if (!transactionId) {
                this.$emit('showError', {
                    message: 'Es trat ein Fehler beim Hochladen eines Belegs auf. Bitte versuche es erneut.',
                    error: 'No transactionId provided.',
                    timeout: 10000
                });
                return false;
            }

            // Ensure AES key is available
            if (!this.$store.state.aes_key_file) {
                const { aes_key, aes_key_file } = await cipher.getAESKeys(this);
                if (aes_key_file === null) {
                    // error has already been shown
                    this.$emit('showError', {
                        message: 'Der Beleg konnte nicht hochgeladen werden, da kein Safe-Schlüssel gefunden wurde. Bitte versuche es erneut, oder stelle sicher dass du in den Einstellungen deinen Safe-Schlüssel hinterlegt hast.',
                        timeout: 10000
                    });
                    return false;
                }
                this.$store.state.aes_key_file = aes_key_file;
            }

            for (let receipt of transObj.receipts) {
                const originalFileName = receipt.name;
                let encryptedFileName = originalFileName;
                // Encrypt the file name using your existing cipher helper.
                if (this.$store.state.aes_key_file) {
                    try {
                        encryptedFileName = await cipher.encryptFileName(this, this.$store.state.aes_key_file, originalFileName);
                    } catch (e) {
                        this.$emit('showError', {
                            message: 'Es trat ein Fehler beim Verschlüsseln des Dateinamens auf. Bitte versuche es erneut.',
                            error: e
                        });
                        success = false;
                        continue;
                    }
                }
                try {
                    const reader = new FileReader();
                    const fileData = await new Promise((resolve, reject) => {
                        reader.onload = (e) => resolve(e.target.result);
                        reader.onerror = reject;
                        reader.readAsArrayBuffer(receipt.file);
                    });
                    const encryptedData = await cipher.encryptFile(this.$store.state.aes_key_file, fileData);
                    const fileSize = receipt.size > 1024 * 1024
                        ? (receipt.size / (1024 * 1024)).toFixed(0) + ' MB'
                        : (receipt.size / 1024).toFixed(0) + ' KB';
                    const fileDataJSON = JSON.stringify({
                        iv: encryptedData.iv,
                        file: encryptedData.file,
                        size: fileSize,
                    });
                    const fType = receipt.file.type ? { type: receipt.file.type } : { type: 'application/octet-stream' };
                    const blob = new Blob([fileDataJSON], fType);
                    const path = userId + '/' + transactionId + '/';
                    const result = await connector.uploadFileToBucket(this, 'receipts', path, encryptedFileName, blob, '3600', 'application/json');
                    if (result === null) {
                        this.$emit('showError', {
                            message: 'Es trat ein Fehler beim Hochladen eines Belegs auf. Bitte versuche es erneut.',
                            timeout: 10000
                        });
                        success = false;
                    }
                } catch (error) {
                    this.$emit('showError', {
                        message: 'Es trat ein Fehler beim Hochladen eines Belegs auf. Bitte versuche es erneut.',
                        error: error,
                        timeout: 10000
                    });
                    success = false;
                }
            }
            return success;
        },

        updateReceipts(newReceipts, transactionId) {
            if (transactionId === null) {
                // we are editing an object
                this.$set(this.editedItem, 'receipts', newReceipts);
            } else {
            const index = this.transactions_to_insert.findIndex(t => t.id === transactionId);
                if (index !== -1) {
                    // Use $set to ensure reactivity
                    this.$set(this.transactions_to_insert[index], 'receipts', newReceipts);
                }
            }
        },

        async fetchTransactionReceipts() {
            const transactionId = this.editedItem.id;
            // Fetch the latest receipts from the bucket
            const fetchedReceipts = await this.fetchReceipts(transactionId);

            // Get the current receipts from the state (which include local modifications)
            const currentReceipts = this.editedItem.receipts || [];

            // Create a lookup map for the current receipts (using a unique key, e.g. id or storageName)
            const currentMap = new Map();
            currentReceipts.forEach(r => {
                // Prefer r.id if available, otherwise fallback to r.storageName
                const key = r.id || r.storageName;
                if (key) {
                    currentMap.set(key, r);
                }
            });

            // Merge the fetched receipts.
            // For each fetched receipt, if it exists in the local state, merge in any local flags (like toDelete)
            const mergedUploaded = fetchedReceipts.map(receipt => {
                const key = receipt.id || receipt.storageName;
                if (currentMap.has(key)) {
                    const localReceipt = currentMap.get(key);
                    // Merge local properties (like toDelete) into the fetched receipt
                    return { ...receipt, toDelete: localReceipt.toDelete };
                }
                return receipt;
            });

            // Filter out locally added receipts (isNew) from the current state – these aren’t part of the fetched list.
            const localNew = currentReceipts.filter(r => r.isNew);

            // Combine the fetched (and merged) receipts with the local new receipts.
            this.editedItem.receipts = [...mergedUploaded, ...localNew];

            // Now update the global allReceipts:
            // 1. Filter out any receipts that belong to this transaction.
            const otherReceipts = this.allReceipts.filter(receipt => receipt.tId !== transactionId);
            // 2. Append the newly fetched receipts for this transaction.
            this.allReceipts = [...otherReceipts, ...fetchedReceipts];
        },

        async fetchReceipts(transactionId = null) {
            const bucket = 'receipts';
            const path = transactionId ? `${this.session.user.id}/${transactionId}/` : `${this.session.user.id}/`;
            try {
                const receipts = await connector.listFiles(this, bucket, this.session.user.id, path);
                return await Promise.all(receipts.map(async (receipt) => {
                    let tId = parseInt(receipt.path_tokens[1]);
                    let original_file_name = receipt.path_tokens.at(-1);
                    let file_name = receipt.path_tokens.at(-1);
                    if (file_name.startsWith("enc:1:") && this.$store.state.aes_key_file) {
                        try {
                            file_name = await cipher.decryptFileName(this, this.$store.state.aes_key_file, file_name);
                        } catch (e) {
                            console.error('Fehler beim Entschlüsseln des Dateinamens:', e);
                            return receipt; // Return unchanged if decryption fails
                        }
                    }
                    return { 
                        ...receipt, 
                        storageName: original_file_name, 
                        isNew: false,
                        toDelete: false,
                        name: file_name, 
                        tId: tId,
                        mimetype: receipt.metadata.mimetype,
                        size: receipt.metadata.size > 1024 * 1024 ? (receipt.metadata.size / (1024 * 1024)).toFixed(0) + ' MB' : (receipt.metadata.size / 1024).toFixed(0) + ' KB'
                    };
                }));
            } catch (error) {
                return [];
            }
        },

    },
    mounted() {
        // code to run when component is mounted here
        this.initialize()
    },

    computed: {

        hasReceiptsForSelectedYear() {
            const year = this.$store.state.selected_year;
            return this.allReceipts.some(receipt => {
                const transaction = this.transactions.find(t => t.id === receipt.tId);
                return transaction && dayjs(transaction.datum).year() === year;
            });
        },

        isFormValid() {
            // If editing an existing transaction
            if (this.editedIndex > -1) {
                if (
                    !this.editedItem.beschreibung ||
                    this.editedItem.betrag === null ||
                    this.editedItem.betrag === '' ||
                    (this.editedItem.kategorie === this.enum_categories['Ausgaben'] && !this.editedItem.verteiler)
                ) {
                    return false;
                }
                return true;
            } else {
                // New transactions: first check if the selected category (if Ausgaben) has a verteiler
                if (this.editedItem.kategorie === this.enum_categories['Ausgaben'] && !this.editedItem.verteiler) {
                    return false;
                }
                // Then check each transaction row in the multi-entry form
                for (let row of this.transactions_to_insert) {
                    const t = row.transaction;
                    if (!t.beschreibung || t.betrag === null || t.betrag === '' || t.betrag === undefined) {
                        return false;
                    }
                }
                return true;
            }
        },

        isFilterActive() {
            return (
                (this.search && this.search.trim() !== '') ||
                this.startDate || this.endDate
            );
        },

        // Calculate the sum of 'Betrag' for the filtered transactions to display as additional row
        sumOfBetrag() {
            return this.fullyFilteredTransactions.reduce(
                (acc, item) => acc + item.betrag,
                0
            );
        },

        dateAndSearchFilteredTransactions() {
            let filtered = [...this.allTransactions];

            // Apply date range filter using dayjs
            if (this.startDate) {
                filtered = filtered.filter(item =>
                    dayjs(item.datum).isSameOrAfter(dayjs(this.startDate), 'day')
                );
            }
            if (this.endDate) {
                filtered = filtered.filter(item =>
                    dayjs(item.datum).isSameOrBefore(dayjs(this.endDate), 'day')
                );
            }

            // Apply search filter
            const search = this.search ? this.search.toLowerCase() : '';
            if (search) {
                filtered = filtered.filter(item => {
                    const dateString = dayjs(item.datum).format('DD.MM.YYYY');
                    const categoryString = item.sortKategorie ? item.sortKategorie.toLowerCase() : '';
                    const beschreibung = item.beschreibung ? item.beschreibung.toLowerCase() : '';
                    const betrag = item.betrag ? item.betrag.toString().toLowerCase() : '';

                    return (
                        beschreibung.includes(search) ||
                        dateString.includes(search) ||
                        categoryString.includes(search) ||
                        betrag.includes(search)
                    );
                });
            }

            return filtered;
        },

        fullyFilteredTransactions() {
            let filtered = [...this.dateAndSearchFilteredTransactions];

            // Apply category filters (income or spending)
            if (this.filter_income) {
                filtered = filtered.filter(
                    transaction => transaction.kategorie === this.enum_categories['Einnahmen']
                );
            } else if (this.filter_spending) {
                filtered = filtered.filter(
                    transaction => transaction.kategorie === this.enum_categories['Ausgaben']
                );
            }

            filtered = filtered.map((item) => {
                item.receipts = [];
                return item;
            });

            // add receipt files to it.
            if (this.allReceipts.length > 0) {
                for (let receipt of this.allReceipts) {
                    let index = filtered.findIndex((item) => item.id === receipt.tId);
                    if (index !== -1) {
                        filtered[index].receipts.push(receipt);
                    }
                }
            }
            return filtered;
        },

        nAllTransactions() {
            return this.dateAndSearchFilteredTransactions.length;
        },

        nIncomeTransactions() {
            return this.dateAndSearchFilteredTransactions.filter(
                transaction => transaction.kategorie === this.enum_categories['Einnahmen']
            ).length;
        },

        nSpendingTransactions() {
            return this.dateAndSearchFilteredTransactions.filter(
                transaction => transaction.kategorie === this.enum_categories['Ausgaben']
            ).length;
        },

        computedEarnings() {
            return this.invoices.filter((invoice) => invoice.bezahlt && dayjs(invoice.bezahlt).year() === this.$store.state.selected_year)
                    .reduce((acc, transaction) => acc + transaction.rechnungs_betrag, 0) + 
                   this.transactions.filter((transaction) => dayjs(transaction.datum).year() === this.$store.state.selected_year && transaction.kategorie === this.enum_categories['Einnahmen'])
                    .reduce((acc, transaction) => acc + transaction.betrag, 0)
        },

        computedEarningsCash() {
            return this.invoices.filter((invoice) => invoice.bezahlt && dayjs(invoice.bezahlt).year() === this.$store.state.selected_year && invoice.bar)
                    .reduce((acc, transaction) => acc + transaction.rechnungs_betrag, 0);
        },

        computedEarningsCashOnly() {
            return this.invoices.filter((invoice) => invoice.bezahlt && dayjs(invoice.bezahlt).year() === this.$store.state.selected_year && invoice.bar && !invoice.bankomat)
                    .reduce((acc, transaction) => acc + transaction.rechnungs_betrag, 0);
        },

        computedEarningsBankomat() {
            return this.invoices.filter((invoice) => invoice.bezahlt && dayjs(invoice.bezahlt).year() === this.$store.state.selected_year && invoice.bankomat)
                    .reduce((acc, transaction) => acc + transaction.rechnungs_betrag, 0);
        },

        computedEarningsCashAndBankomat() {
            return this.invoices.filter((invoice) => invoice.bezahlt && dayjs(invoice.bezahlt).year() === this.$store.state.selected_year && invoice.bar)
                    .reduce((acc, transaction) => acc + transaction.rechnungs_betrag, 0);
        },

        computedEarningsTransfer() {
            return this.invoices.filter((invoice) => invoice.bezahlt && dayjs(invoice.bezahlt).year() === this.$store.state.selected_year && !invoice.bar)
                    .reduce((acc, transaction) => acc + transaction.rechnungs_betrag, 0);
        },

        // Smart display logic for payment method rows
        hasCashOnlyPayments() {
            return this.computedEarningsCashOnly > 0;
        },

        hasBankomatPayments() {
            return this.computedEarningsBankomat > 0;
        },

        hasTransferPayments() {
            return this.computedEarningsTransfer > 0;
        },

        hasMixedPayments() {
            return this.hasCashOnlyPayments && this.hasBankomatPayments;
        },

        computedEarningsPerTax() {

            let earnings_treatment = this.invoices.filter((invoice) => invoice.bezahlt && dayjs(invoice.bezahlt).year() === this.$store.state.selected_year)
                                                  .reduce((acc, transaction) => acc + transaction.betrag_steuer_behandlung, 0);

            let earnings_supervision = this.invoices.filter((invoice) => invoice.bezahlt && dayjs(invoice.bezahlt).year() === this.$store.state.selected_year)
                                                    .reduce((acc, transaction) => acc + transaction.betrag_steuer_supervision, 0);

            let earnings_kleinunternehmer = this.invoices.filter((invoice) => invoice.bezahlt && dayjs(invoice.bezahlt).year() === this.$store.state.selected_year)
                                                         .reduce((acc, transaction) => acc + transaction.betrag_steuer_kleinunternehmer, 0);

            let earnings_nicht_zugeordnet = this.invoices.filter((invoice) => invoice.bezahlt && dayjs(invoice.bezahlt).year() === this.$store.state.selected_year)
                                                         .reduce((acc, transaction) => acc + transaction.betrag_steuer_nicht_zugeordnet, 0);

            let other_incomes = this.transactions.filter((transaction) => dayjs(transaction.datum).year() === this.$store.state.selected_year && transaction.kategorie === this.enum_categories['Einnahmen'])
                                                 .reduce((acc, transaction) => acc + transaction.betrag, 0);

            return {
                'behandlung': earnings_treatment,
                'supervision': earnings_supervision,
                'kleinunternehmer': earnings_kleinunternehmer,
                'sonstige': other_incomes + earnings_nicht_zugeordnet
            };     
        },

        computedSpendings() {
            return this.transactions.filter((transaction) => dayjs(transaction.datum).year() === this.$store.state.selected_year && transaction.kategorie === this.enum_categories['Ausgaben']).reduce((acc, transaction) => acc - transaction.betrag, 0)
        },

        formTitle() {
            if (this.editedIndex === -1) {
                return (this.editedItem.kategorie === this.enum_categories['Ausgaben']) ? 'Neue Ausgabe' : 'Neue Einnahme'
            } else {
                return (this.editedItem.kategorie === this.enum_categories['Ausgaben']) ? 'Ausgabe bearbeiten' : 'Einnahme bearbeiten'
            }
        },

        computedDateFormatted() {
            return this.formatDate(this.editedItem.datum)
        },

        allTransactions() {
            return this.transactions.filter((transaction) => [this.enum_categories['Einnahmen'], this.enum_categories['Ausgaben']].includes(transaction.kategorie))
                .concat(this.transactionsFromInvoices)
                .map(item => {
                return {
                    ...item,
                    sortKategorie: this.getCategoryDisplayText(item)
                };
            });
        },

        transactionsFromInvoices() {
            let paid_invoices = this.invoices.filter((invoice) => invoice.bezahlt).map((invoice) => {
                let description = invoice.nummer + ' | ';

                if (invoice.fk_klienten_id) {
                    description += invoice.nachname + ' ' + invoice.vorname;
                } else {
                    description += invoice.empfänger_name;
                }

                return {
                    id: 'inv_' + invoice.id,
                    datum: invoice.bezahlt,
                    beschreibung: description,
                    nummer: invoice.nummer,
                    bar: invoice.bar,
                    bankomat: invoice.bankomat,
                    paymentMethod: invoice.bankomat ? 'bankomat' : (invoice.bar ? 'cash' : 'transfer'),
                    betrag: invoice.rechnungs_betrag,
                    svs_prozent_ruecklagen: invoice.svs_prozent_ruecklagen,
                    kategorie: this.enum_categories['Einnahmen'],
                    deletable: false,
                    inserted_at: invoice.updated_at, // use updated_at as inserted_at due to the fact it is updated when the invoice is marked as paid
                    updated_at: invoice.updated_at
                }
            })
            return paid_invoices
        },
    }
};
</script>

<style>
.year-selector {
    max-width: 200px !important;
}
.custom-header-height .v-data-table__wrapper > table > thead > tr > th {
    height: 48px !important;
}
</style>

<style scoped>
.v-data-table >>> .no-hover:hover {
  background-color: transparent !important;
  cursor: default;
}
.custom-header-height ::v-deep .clickable-row {
  cursor: pointer !important;
}
.v-sheet.v-card {
  border-radius: 6px;
}
</style>